export default __webpack_public_path__ + "static/media/eye-black-icon.72ad9ae8.svg";